import { nothing } from 'maybeasy';
import { BrowseAllDefaults } from '../Types/SectionTemplates';
import { ProductCollectionResource } from '../Types';

/**
 * Creates a Browse All product collection resource from defaults.
 * Browse All sections automatically include all available programs.
 */
export const createBrowseAllSection = (
  browseAllDefaults: BrowseAllDefaults,
): ProductCollectionResource => ({
  payload: {
    id: nothing<number>(),
    name: browseAllDefaults.name,
    description: browseAllDefaults.description,
    kind: 'learning-design' as const,
    display_type: browseAllDefaults.display_type,
    experiences: browseAllDefaults.experiences,
    browse_all: true,
    learning_design_state: 'browse-all' as const,
    display_per_page_count: 12,
    display_button_label: nothing<string>(),
  },
  links: [],
});

/**
 * Checks if a Browse All section can be added to the collection.
 * Only one Browse All section is allowed per collection.
 *
 * NOTE: Only checks the `browse_all` flag, not `learning_design_state`.
 * When a Browse All section is modified, `browse_all` is set to false
 * (making it a regular section), but `learning_design_state` remains
 * 'browse-all' to preserve template origin metadata.
 */
export const canAddBrowseAll = (
  productCollections: readonly ProductCollectionResource[],
): boolean => {
  return !productCollections.some((pc) => pc.payload.browse_all === true);
};
